/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETFEEDLIKEDUSERS= createAsyncThunk(
  "getFeedLikedUsers/getFeedLikedUsers",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getFeedLikedUsersSlice = createSlice({
  name: "getFeedLikedUsersSlice",
  initialState: {
    getFeedLikedUsers: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetFeedLikedUsers: (state) => {
        state.getFeedLikedUsers.loading = false
        state.getFeedLikedUsers.error = false
        state.getFeedLikedUsers.data = []
        state.getFeedLikedUsers.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETFEEDLIKEDUSERS.fulfilled, (state, action) => {
      state.getFeedLikedUsers = {
        ...state.getFeedLikedUsers,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETFEEDLIKEDUSERS.pending, (state, action) => {
      state.getFeedLikedUsers = {
        ...state.getFeedLikedUsers,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETFEEDLIKEDUSERS.rejected, (state, action) => {
      state.getFeedLikedUsers = {
        ...state.getFeedLikedUsers,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getFeedLikedUsersAction = {
    GETFEEDLIKEDUSERS,
};

export { getFeedLikedUsersAction };
export default getFeedLikedUsersSlice.reducer;
export const {setInitialStateOfgetFeedLikedUsers} = getFeedLikedUsersSlice.actions